var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      {
        class: [
          "refresh-box",
          !_vm.companyInfo.refreshEnable || _vm.loading ? "enable" : "",
        ],
        on: {
          click: function ($event) {
            !_vm.companyInfo.refreshEnable || _vm.loading
              ? function () {}
              : _vm.onRefresh()
          },
        },
      },
      [
        !_vm.loading
          ? _c("img", {
              staticClass: "load",
              attrs: { src: require("@/assets/newicons/shauxin.png"), alt: "" },
            })
          : _c("img", {
              staticClass: "load xuanzhuan001",
              attrs: { src: require("@/assets/newicons/ib02.png"), alt: "" },
            }),
        _vm.loading
          ? _c("span", { staticClass: "refresh-tip" }, [
              _vm._v("数据更新中..."),
            ])
          : _c("span", { staticClass: "refresh-tip" }, [
              _vm._v(_vm._s(_vm._updateTime)),
            ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }